import { textStyles } from "../../styles/typography";
import { ccn, cn } from "../../styles/utils";
import { useAtomValue } from "jotai";
import { customerDetailsAtom } from "./store";
import Button from "../ui/Button";
import { CheckIcon } from "../ui/icons";
import Header from "./Header";

export default function ExistingCustomerEmailSent() {
  const customerDetails = useAtomValue(customerDetailsAtom);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-full max-w-5xl bg-white md:rounded-3xl min-h-screen md:min-h-[unset]">
        <Header showBoatInfo={false} />

        <div className="md:p-5 pt-6 px-3">
          <div className="bg-green-primary/15 text-green-primary rounded-lg flex flex-col items-center text-center mb-5 p-3 md:p-10 gap-4">
            <div className="bg-green-primary/20 rounded-full p-3">
              <CheckIcon className="w-8 h-8" />
            </div>

            <h1 className={ccn(textStyles.h1, "mb-1")}>Check Your Email</h1>

            <div className={cn(textStyles.body1, "md:max-w-screen-sm")}>
              We've sent a booking confirmation to
              <br />
              <strong className="break-all">{customerDetails?.email}</strong>
            </div>

            <div className={cn(textStyles.body1, "md:max-w-screen-sm")}>
              Please check your inbox and follow the link to view your booking
              details and complete the payment.
            </div>
          </div>

          <Button
            type="button"
            variant="primary"
            className="w-full"
            onClick={() => {
              window.parent.postMessage({ close: true }, "*");
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
